/** This code hides the left column of the steal this deck form on successul submission.
 * It'll also widen up the confirmation to 12 cols :)
 */
jQuery(document).on('gform_confirmation_loaded', function (event, formId) {
    $('#gform_confirmation_wrapper_' + formId).closest('.steal-form').find('.file-info-form').addClass('cols-sm-12').removeClass('col-sm-6');
    $('#gform_confirmation_wrapper_' + formId).closest('.steal-form').find('.col-sm-6:first').hide();
});


/** This will add a class to any gravity forms select field, prior to selection, to allow custom styling */
document.addEventListener('DOMContentLoaded', function() {
    const selects = document.querySelectorAll('.gfield select');
  
    selects.forEach(function(select) {
        function updateClass() {
            const selectedOption = select.options[select.selectedIndex];
  
            if (selectedOption.classList.contains('gf_placeholder')) {
                select.classList.add('gselect-placeholder');
            } else {
                select.classList.remove('gselect-placeholder');
            }
        }
  
        select.addEventListener('change', updateClass);
        updateClass();
    });
});